document.addEventListener("DOMContentLoaded", function () {
  initMap();
});

/**
 * Main map initialization function
 * HTML Element ID used:
 * - map: The container for the Leaflet map showing the area code region
 */
function initMap() {
  // Check if map container exists
  const mapContainer = document.getElementById('map');
  if (!mapContainer) {
    return;
  }

  // Check if map data exists
  if (!apiData || !apiData.map || !apiData.map.data || !apiData.map.data.regions_map || 
      !apiData.map.data.regions_map[1]) {
    mapContainer.innerHTML = '<div class="p-4 text-center bg-light"><p class="text-muted">Map data not available for this area code</p></div>';
    return;
  }

  try {
    const rawGeometryString = apiData.map.data.regions_map[1];
    const rawGeometry = JSON.parse(rawGeometryString);

    const currentPosition = window.getComputedStyle(mapContainer).position;
    if (currentPosition === 'static') {
      mapContainer.style.position = 'relative';
    }
    
    // Create and append spinner
    const spinner = document.createElement('div');
    spinner.classList.add('map-loading-spinner');
    spinner.style.cssText = `
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50px;
      height: 50px;
      border: 5px solid rgba(46, 49, 146, 0.2);
      border-radius: 50%;
      border-top-color: #2e3192;
      z-index: 1000;
      animation: spinner-rotate 1s linear infinite;
    `;
    
    const style = document.createElement('style');
    style.textContent = `
      @keyframes spinner-rotate {
        0% { transform: translate(-50%, -50%) rotate(0deg); }
        100% { transform: translate(-50%, -50%) rotate(360deg); }
      }
      
      .map-loading-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255);
        z-index: 999;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    `;
    document.head.appendChild(style);
    
    const overlay = document.createElement('div');
    overlay.classList.add('map-loading-overlay');
    
    mapContainer.appendChild(overlay);
    mapContainer.appendChild(spinner);

    const wrappedPolygon = {
      type: "FeatureCollection",
      features: [{
        type: "Feature",
        geometry: rawGeometry,
        properties: {
          name: "Area Code Region"
        }
      }]
    };

    const map = L.map('map', {
      minZoom: 1,
      maxZoom: 15,
      zoomSnap: 1,
      zoomDelta: 1,
      dragging: true,
      scrollWheelZoom: true,
      doubleClickZoom: true
    });

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      attribution: '',
      subdomains: 'abcd',
      maxZoom: 19
    }).addTo(map);

    map.attributionControl.setPrefix(false);

    const layer = L.geoJSON(wrappedPolygon, {
      style: {
        color: '#2e3192',
        weight: 2,
        fillColor: '#2e3192',
        fillOpacity: 0.6
      }
    }).addTo(map);

    const bounds = layer.getBounds();
    const paddedBounds = bounds.pad(0.1);

    map.fitBounds(paddedBounds);

    map.on('load', function() {
      removeMapSpinner();
    });

    setTimeout(removeMapSpinner, 1500);

    /**
     * Removes the loading spinner and overlay from the map
     */
    function removeMapSpinner() {
      const spinner = document.querySelector('.map-loading-spinner');
      const overlay = document.querySelector('.map-loading-overlay');
      
      if (spinner) {
        spinner.style.opacity = '0';
        spinner.style.transition = 'opacity 0.5s';
        setTimeout(() => spinner.remove(), 500);
      }
      
      if (overlay) {
        overlay.style.opacity = '0';
        overlay.style.transition = 'opacity 0.5s';
        setTimeout(() => overlay.remove(), 500);
      }
    }

    setTimeout(() => {
      map.invalidateSize();
      
      if (map.dragging && typeof map.dragging.enable === 'function') {
        map.dragging.enable();
      }
      
      
      if (map.touchZoom) map.touchZoom.enable();
      if (map.doubleClickZoom) map.doubleClickZoom.enable();
      if (map.scrollWheelZoom) map.scrollWheelZoom.enable();
      if (map.boxZoom) map.boxZoom.enable();
      if (map.keyboard) map.keyboard.enable();
      
    }, 800);
  } catch (error) {
    console.error('Error initializing map:', error);
  }
}

export default initMap;